export default __webpack_public_path__ + "static/media/MAKE_AN_APPOINTMENT.c973917b.svg";